import React from 'react'
import { Button, Popup, Menu } from 'semantic-ui-react'
import firebase from 'firebase/app'

class RegionPopUp extends React.Component {
  state = {
    loading: false,
    selectingId: null,
  }

  onClick = async region => {
    try {
      const { auth } = this.props
      const doc = firebase.firestore().collection('dashboard_users').doc(auth.uid)

      this.setState({ loading: true, selectingId: region })

      await doc.update({ region })
      window.location.reload()
    } catch (err) {
      alert(err)
    }
  }

  render() {
    const { userRegion, regions } = this.props
    const { loading, selectingId } = this.state

    return (
      <Popup
        on='click'
        trigger={
          <Menu.Item>
            <b style={{ textTransform: 'uppercase' }}>{userRegion}</b>
          </Menu.Item>
        }
        position="bottom center"
        style={{ width: 190 }}
      >
        {
          regions.map(region => (
            <Button
              key={region.id}
              style={{ width: 170, marginBottom: 5 }}
              onClick={() => this.onClick(region.id)}
              loading={loading && selectingId === region.id}
              disabled={loading}
            >
              {region.name}
            </Button>
          ))
        }
      </Popup>
    )
  }
}

export default RegionPopUp


// WEBPACK FOOTER //
// ./src/components/common/RegionPopUp.js